import { instance } from '@/services/avik-api-gateway'
import { DeviationDisruptionReason } from '@/types/deviation-disruption-reason'
import { AxiosResponse } from 'axios'

export function getDeviationDisruptionReasons(): Promise<
  AxiosResponse<DeviationDisruptionReason[]>
> {
  return instance.get(`/deviation-disruption-activity`)
}
